import { getLocalToken } from "../services/authorizationService"
import { logout } from "../services/authorizationService";
import { showError } from "../services/toastServices";
import axios from 'axios';

export const URL = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_API_URL
    : process.env.REACT_APP_BASE_API_URL

/**
 * Función auxiliar para reintentar peticiones fallidas automáticamente
 * @param {Function} requestFn - Función que retorna una promesa (la petición axios)
 * @param {number} maxRetries - Número máximo de reintentos (por defecto 2)
 * @param {number} retryDelay - Delay entre reintentos en ms (por defecto 1000)
 * @returns {Promise} - Promesa de la petición
 */
export const retryRequest = async (requestFn, maxRetries = 2, retryDelay = 1000) => {
    let lastError;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await requestFn();
        } catch (error) {
            lastError = error;
            // Si es el último intento o es un error 401/403, no reintentar
            if (attempt === maxRetries || 
                (error.response && (error.response.status === 401 || error.response.status === 403))) {
                throw error;
            }
            // Solo reintentar en errores de red o timeouts
            if (!error.response || error.code === 'ECONNABORTED') {
                await new Promise(resolve => setTimeout(resolve, retryDelay * (attempt + 1)));
            } else {
                throw error;
            }
        }
    }
    throw lastError;
}

export const createAxiosInstance = ((controllerName)=>{
    const token = getLocalToken()
    const axiosApiInstance = axios.create({
        baseURL: `${URL}/${controllerName}`,
        headers: {'Authorization':`bearer ${token}`},
        timeout: 15000 // 15 segundos de timeout para todas las peticiones
    });
    // axiosApiInstance.interceptors.request.use(function (config) {
    //     const token = getLocalToken();
    //     config.headers.Authorization =  token ? `Bearer ${token}` : '';
    //     return config;
    // });    
    axiosApiInstance.interceptors.response.use((response) => {
        return response
      }, async function (error) {
        if(!error.response){
            // Diferenciar entre timeout y error de conexión
            if (error.code === 'ECONNABORTED') {
                showError('Tiempo de espera agotado. Intente nuevamente.')
            } else if (error.message === 'Network Error') {
                showError('Error de red. Verifique su conexión.')
            } else {
                showError('Error de conexión')
            }
        }else{
            const originalRequest = error.config;
            if (error.response.status === 401 || error.response.status === 403) {
                logout();
                window.location.href = "/login";
                return axiosApiInstance(originalRequest);
            }
        }
        return Promise.reject(error);
    });
    return axiosApiInstance;

})

